<nz-header class="table-header">
  <div class="table-header-row margin-lr">
    <div class="table-header-cell">
      {{ "Stroke Score Questionnaire" | translate }}
    </div>
  </div>
</nz-header>

@if (!isLoading) {
<form style="margin-bottom: 10em" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <nz-steps [nzCurrent]="current" [nzProgressDot]="progressTemplate" (nzIndexChange)="onIndexChange($event)"
    [nzDirection]="isLargeScreen ? 'horizontal' : 'vertical'">
    @for (page of pages; track page; let i = $index) {
    <nz-step [nzTitle]="page.title" [nzDisabled]="disable && i > current" [nzDescription]="
          !isLargeScreen && i === current && page.elements
            ? strokeScoreQuestionsTemplate
            : ''
        "></nz-step>
    }
  </nz-steps>
  <!-- Template for dynamic questions in vertical mode -->
  <ng-template #strokeScoreQuestionsTemplate>
    <app-stroke-score-mediterranean-questions [elements]="pages[current].elements" [formGroup]="formGroup"></app-stroke-score-mediterranean-questions>
  </ng-template>
  <ng-template #progressTemplate let-dot let-status="status" let-index="index">
    <span nz-popover>
      <ng-template [ngTemplateOutlet]="dot"></ng-template>
    </span>
  </ng-template>
  <!-- Render questions below steps in horizontal mode -->
  @if (isLargeScreen && pages[current].elements) {
  <app-stroke-score-mediterranean-questions [elements]="pages[current].elements" [formGroup]="formGroup"></app-stroke-score-mediterranean-questions>
  }
  <div class="notes">
    <span><b><u>{{ "Notes" | translate }}</u></b></span>
    <ul>
      <li>{{ "StrokeScoreNote1" | translate }}</li>
      <li>{{ "StrokeScoreNote2" | translate }}</li>
      <li>{{ "StrokeScoreNote3" | translate }}</li>
    </ul>
  </div>
  <div class="steps-action">
    <div class="left-actions">
      <button nz-button nzType="default" (click)="pre($event)" [disabled]="!(current > 0)" class="previous">
        <span>{{ "Previous" | translate }}</span>
      </button>
      <button nz-button nzType="default" (click)="next($event)" [disabled]="!(current < pages.length - 1)">
        <span>{{ "Next" | translate }}</span>
      </button>
    </div>
    <div class="right-actions" *hasAddPermissions="['a-nih']">
      @if (formInitialized && (isInpatientView() || isEOC())) {
      <button nz-button nzDanger class="cancel-btn" type="button" (click)="revertForm()" [disabled]="!hasChanges">
        <span>{{ "Revert" | translate }}</span>
      </button>
      }
      @if (formInitialized && (isInpatientView() || isEOC())) {
      <button nz-button nzType="primary" type="submit" [disabled]="!hasChanges">
        <span>{{ "Submit" | translate }}</span>
      </button>
      }
    </div>
  </div>
</form>
}

@if (isLoading) {
<nz-spin [nzSpinning]="true" nzSize="large"></nz-spin>
}